import React from 'react';
import type { ClientInvoiceViewModel } from '../../lib/clientInvoiceTemplate';
import ClientInvoiceHeader from './ClientInvoiceHeader';
import ClientInvoiceDocumentBody from './ClientInvoiceDocumentBody';

interface ClientInvoicePrintDocumentProps {
  viewModel: ClientInvoiceViewModel;
}

/** Full invoice layout used for preview parity and PDF capture. */
const ClientInvoicePrintDocument: React.FC<ClientInvoicePrintDocumentProps> = ({ viewModel }) => {
  return (
    <div
      className="box-border w-[794px] max-w-full bg-white p-8 text-gray-900"
      style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}
    >
      <ClientInvoiceHeader viewModel={viewModel} />
      <ClientInvoiceDocumentBody viewModel={viewModel} />
    </div>
  );
};

export default ClientInvoicePrintDocument;
